import zwitCore from "./http";
const BASE_URL = "/apis/zw-user";
import { jsonp } from 'vue-jsonp'
export default {
  getPk() {
    return zwitCore.HTTP.get(BASE_URL + "/getPk");
  },
  // 获取公网ip地址接口(腾讯三方 https://lbs.qq.com/service/webService/webServiceGuide/webServiceIp)
  getUserIpConfig() {
    return new Promise((resolve, reject) => {
      jsonp(`https://apis.map.qq.com/ws/location/v1/ip?key=YFTBZ-LCIWT-OOGXF-VWUF4-PXHK6-T6BVO`, {
        output: 'jsonp',
      }).then(resp => {
        resolve(resp)
      }).catch(err => {
        console.log(err);
      })
    })
  }
};
